import { ref } from 'vue'
import { useNuxtApp } from '#imports'

export const useDownloadCounter = (book, property) => {
  const numberOfDownloadsLeft = book.download[property]
    ? book.download[property].numberOfDownloadsLeft
    : 0
  const currentDownloadCount = ref(0)

  const downloadsLeft = () => {
    return Math.max(numberOfDownloadsLeft - currentDownloadCount.value, 0)
  }

  const incrementDownloadCount = () => currentDownloadCount.value++

  return {
    currentDownloadCount,
    downloadsLeft,
    incrementDownloadCount,
  }
}

export const useDownloadOptions = (props) => {
  const { $label } = useNuxtApp()
  const options = ref([])

  if (props.ebookDownloadable) {
    options.value.push({ id: 'ebook', label: $label('common.ebook') })
  }

  if (props.audiobookDownloadable) {
    options.value.push({
      id: 'audiobook',
      label: $label('books.audiobook'),
    })
  }

  return options
}
